/* ============================================================
   ZENITH APPAREL — Collection page JS (filter + sort)
   ============================================================ */
(function() {
  const filterBtn = document.querySelector('.collection-filter-btn');
  const filtersEl = document.getElementById('CollectionFilters');
  const filtersClose = filtersEl?.querySelector('.collection-filters__close');
  const filtersApply = filtersEl?.querySelector('.collection-filters__apply-btn');
  const sortSelect = document.getElementById('SortBy');

  /* ---- Filter drawer (mobile) / sidebar (desktop) ---- */
  if (filterBtn && filtersEl) {
    filterBtn.addEventListener('click', function() {
      const isOpen = filtersEl.getAttribute('aria-hidden') === 'false';
      filtersEl.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      this.setAttribute('aria-expanded', !isOpen);
      if (!isOpen) document.body.style.overflow = 'hidden';
      else document.body.style.overflow = '';
    });
  }

  if (filtersClose) {
    filtersClose.addEventListener('click', function() {
      if (filtersEl) filtersEl.setAttribute('aria-hidden', 'true');
      if (filterBtn) filterBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  }

  /* ---- Filter accordion ---- */
  document.querySelectorAll('.collection-filter-group__toggle').forEach(toggle => {
    toggle.addEventListener('click', function() {
      const expanded = this.getAttribute('aria-expanded') !== 'false';
      this.setAttribute('aria-expanded', !expanded ? 'true' : 'false');
      const body = this.nextElementSibling;
      if (body) body.hidden = expanded;
    });
  });

  /* ---- Sort ---- */
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ---- Apply filters (mobile) ---- */
  if (filtersApply) {
    filtersApply.addEventListener('click', function() {
      const url = new URL(window.location.href);
      // Collect all checked filters
      document.querySelectorAll('.collection-filter-item__checkbox:checked').forEach(cb => {
        url.searchParams.append(cb.name, cb.value);
      });
      // Price range
      const minInput = document.querySelector('.collection-filter-price__input[name]');
      const maxInputs = document.querySelectorAll('.collection-filter-price__input');
      maxInputs.forEach(input => {
        if (input.value) url.searchParams.set(input.name, input.value);
      });
      window.location.href = url.toString();
    });
  }

  /* ---- Immediate filter (desktop auto-apply on checkbox change) ---- */
  if (window.innerWidth >= 750) {
    document.querySelectorAll('.collection-filter-item__checkbox').forEach(cb => {
      cb.addEventListener('change', function() {
        const url = new URL(window.location.href);
        // Clear existing filter params, rebuild
        document.querySelectorAll('.collection-filter-item__checkbox:checked').forEach(checkedCb => {
          url.searchParams.append(checkedCb.name, checkedCb.value);
        });
        window.location.href = url.toString();
      });
    });
  }
})();
